import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Synonym } from "@/model";
import SynonymRepository from "@/repository/synonymRepository";
import { synonymQueryKeys } from "./keys";


export const useUpdateSynonym = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Synonym[], AxiosError, Synonym>({
        mutationKey: ["synonym", "agent", agentId, "update"],
        mutationFn: async (updatedSynonym: Synonym) => {
            const res = await SynonymRepository.update(agentId, updatedSynonym);
            return res.data.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: synonymQueryKeys.all(agentId) });
        }
    });
};